// View types icons
import SeaViewIcon from "./view-types/sea-view.svg";
import ParkViewIcon from "./view-types/park-view.svg";
import LakeViewIcon from "./view-types/lake-view.svg";
import RiverViewIcon from "./view-types/river-view.svg";
import OceanViewIcon from "./view-types/ocean-view.svg";
import ValleyViewIcon from "./view-types/valley-view.svg";
import SunsetViewIcon from "./view-types/sunset-view.svg";
import DesertViewIcon from "./view-types/desert-view.svg";
import GardenViewIcon from "./view-types/garden-view.svg";
import ForestViewIcon from "./view-types/forest-view.svg";
import MarinaViewIcon from "./view-types/marina-view.svg";
import HillsideViewIcon from "./view-types/hillside-view.svg";
import MountainViewIcon from "./view-types/mountain-view.svg";
import VineyardViewIcon from "./view-types/vineyard-view.svg";
import PanoramicViewIcon from "./view-types/panoramic-view.svg";
import WaterfrontViewIcon from "./view-types/waterfront-view.svg";
import BeachfrontViewIcon from "./view-types/beachfront-view.svg";
import GolfCourseViewIcon from "./view-types/golf-course-view.svg";
import CountrysideViewIcon from "./view-types/countryside-view.svg";
import CitySkylineViewIcon from "./view-types/city-skyline-view.svg";

export const ViewTypesIconMapping = {
  sea_view: SeaViewIcon,
  park_view: ParkViewIcon,
  lake_view: LakeViewIcon,
  river_view: RiverViewIcon,
  ocean_view: OceanViewIcon,
  forest_view: ForestViewIcon,
  garden_view: GardenViewIcon,
  valley_view: ValleyViewIcon,
  desert_view: DesertViewIcon,
  marina_view: MarinaViewIcon,
  sunset_view: SunsetViewIcon,
  mountain_view: MountainViewIcon,
  vineyard_view: VineyardViewIcon,
  hillside_view: HillsideViewIcon,
  panoramic_view: PanoramicViewIcon,
  waterfront_view: WaterfrontViewIcon,
  beachfront_view: BeachfrontViewIcon,
  golf_course_view: GolfCourseViewIcon,
  countryside_view: CountrysideViewIcon,
  city_skyline_view: CitySkylineViewIcon,
};

export default ViewTypesIconMapping;
